<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm04">
<div class="chapterHead">
<h2 class="chapterTitle1" style="text-indent: 0%;"><span class="bold">Tables of Genealogy</span></h2>
</div>
<div class="chapterBody">
<p class="paraCenter" style="text-indent:0%;"><span class="xrefInternal"><a href="#/9781466805798_fm04#img_23a">1. The Tudors</a></span></p>
<p class="paraCenter" style="text-indent:0%;"><span class="xrefInternal"><a href="#/9781466805798_fm04#img_23b">2. The Seymours</a></span></p>
<p class="paraCenter" style="text-indent:0%;"><span class="xrefInternal"><a href="#/9781466805798_fm04#img_23c">3. The Dudleys</a></span></p>
<p class="paraCenter" style="text-indent:0%;"><span class="xrefInternal"><a href="#/9781466805798_fm04#img_24a">4. The Howards</a></span></p>
<p class="newPage"> </p>
<p class="centerImage"><img alt="image" class="epubimage" src="Images/22.gif"/></p>
<p class="centerImage"><img alt="image" class="epubimage" id="img_23a" src="Images/23a.gif"/></p>
<p class="centerImage"><img alt="image" class="epubimage" id="img_23b" src="Images/23b.gif"/></p>
<p class="centerImage"><img alt="image" class="epubimage" id="img_23c" src="Images/23c.gif"/></p>
<p class="centerImage"><img alt="image" class="epubimage" id="img_24a" src="Images/24a.gif"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466805798_fm04.vue?5500e4f5